export default __webpack_public_path__ + "static/media/link_icon.ddb936cb.svg";